<template>
  <div class="page-class page-user-list">
    <h1 class="page-title text-center">{{ title }}</h1>
    <silver-coin-box
      :columns="columns"
      :rows="tickets"
      :baseUrl="baseUrl"
      :loading="loading"
      :searchItems="searchItems"
      :showAdd="ifAdmin() || ifREPAIRING_MAINTENANCE_HEAD()"
      addText="Download Report"
      :filterOptions="filterOptions"
      :showSearch="true"
      :showFilter="true"
      :showToolbar="true"
      :showPagination="true"
      :pagination="pagination"
      @edit="onEdit"
      @add="onDownloadReport"
      emptyText="No Data Found."
      @check="onCheck"
    >
    </silver-coin-box>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import _ from 'lodash';
import Vue from 'vue';
import SilverCoinBox from '../../components/SilverCoinBox.vue';

export default {
  components: { SilverCoinBox },
  name: 'SilverCoinList',
  metaInfo() {
    return {
      title: 'Tickets',
      meta: [
        {
          name: 'tickets',
          content: `Download mis-tickets`
        }
      ]
    };
  },
  data() {
    return {
      title: 'Complaint Tracker',
      submittedBy: '6110cc4a9ad37e165b73eb6f',
      searchItems: ['Complain Number', 'Store Id'],
      filterOptions: [
        { value: null, text: 'Select Filter' },
        { value: 'Resolved-False', text: 'Resolved-False' },
        { value: 'Resolved-True', text: 'Resolved-True' },
        { value: 'Status-OPEN', text: 'Status-Open' },
        { value: 'Status-IN PROGRESS', text: 'Status-In Progress' },
        { value: 'Status-CANCEL', text: 'Status-In CANCEL' },
        { value: 'Issue Priority-Non Critical', text: 'Severity-Non Critical' },
        { value: 'Issue Priority-Critical', text: 'Severity-Critical' }
      ],
      columns: [
        {
          type: 'row_num',
          headerText: '#',
          class: { ' text-center': true },
          textKey: 'rowNum',
          width: '3%'
        },
        {
          type: 'string',
          headerText: 'Name',
          class: { 'text-center': true },
          textKey: 'name',
          width: '5%'
        },
        {
          type: 'string',
          headerText: 'Mobile',
          class: { 'text-center': true },
          textKey: 'mobile',
          width: '6%'
        },
        {
          type: 'string',
          headerText: 'Email',
          class: { 'text-center': true },
          textKey: 'email',
          width: '6%'
        },
        {
          type: 'string',
          headerText: 'Severity',
          class: { 'text-center': true },
          textKey: 'issuePriority',
          width: '6%'
        },
        {
          type: 'string',
          headerText: 'Issue',
          class: { 'text-center': true },
          textKey: 'issue',
          width: '14%'
        },
        {
          type: 'string',
          headerText: 'Store Id',
          class: { 'text-center': true },
          textKey: 'storeid',
          width: '5%'
        },
        {
          type: 'string',
          headerText: 'Complaint No.',
          class: { 'text-center': true },
          textKey: 'complainNumber',
          width: '7%'
        },
        {
          type: 'string',
          headerText: 'Attachment',
          class: { 'text-center': true },
          urlKey: 'imageUrl',
          width: '7%'
        },
        {
          type: 'string',
          headerText: 'Department',
          class: { 'text-center': true },
          textKey: 'department',
          width: '8%'
        },
        {
          type: 'string',
          headerText: 'Category',
          class: { 'text-center': true },
          textKey: 'subDepartment',
          width: '8%'
        },

        {
          type: 'string',
          headerText: 'Submitted By',
          class: { 'text-center': true },
          textKey: 'submittedByName',
          width: '8%'
        },
        {
          type: 'string',
          headerText: 'Aging',
          class: { 'text-center': true },
          textKey: 'aging',
          width: '9%'
        },
        {
          type: 'functions',
          headerText: 'Functions',
          class: { 'text-center': true },
          width: '8%',
          functions: {
            customEdit: true,
            delete: false,
            checkstatus: true
          }
        }
      ]
    };
  },
  mounted() {
    if (_.isEmpty(this.$route.query)) {
      this.listTickets({
        query: {
          ...this.$route.query,
          startdate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
          enddate: moment().format('YYYY-MM-DD')
        }
      });
    } else {
      this.listTickets({ query: this.$route.query });
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.listTickets({ query: to.query });
    next();
  },
  methods: {
    ...mapActions('contactUs', ['listTickets', 'downloadReport']),
    onDownloadReport() {
      this.downloadReport({ query: { ...this.$route.query, page_size: 99999 } });
    },
    onCheck({ row }) {
      const cancelReasonSection =
        row.cancelReason && row.cancelReason.trim() !== ''
          ? `<div class="form-group">
         <label for="cancelReason">Cancel Reason</label>
         <textarea class="form-control" id="cancelReason" rows="3" disabled>${row.cancelReason}</textarea>
       </div>`
          : '';

      Vue.swal({
        title: 'Ticket Details',
        html: `<div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="name">Ticket Current Status</label>
          <input type="text" class="form-control" id="name" value="${row.currentStatus}" disabled>
        </div>
        <div class="form-group">
          <label for="mobile">Tentative Date</label>
          <input type="text" class="form-control" id="mobile" value="${
            row.tentativeDate ? moment(row?.tentativeDate).format('DD-MM-YYYY') : '-'
          }" disabled>
        </div>
        ${cancelReasonSection}
      </div>
    </div>`,
        showCancelButton: false,
        confirmButtonText: 'Ok',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark',
          confirmButton: 'btn btn-primary',
          popup: 'col-md-3 animate__animated animate__fadeInDown',
          input: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      });
    },
    onEdit({ row }) {
      this.$router.push(`/complain/${row.id}`);
    },
    ifAdmin() {
      const isAdmin = this.user.roles.filter(role => role.name === 'SUB_ADMIN' || role.name === 'ADMIN');
      if (isAdmin.length) {
        return true;
      }
      return false;
    },
    ifREPAIRING_MAINTENANCE_HEAD() {
      const isREPAIRING_MAINTENANCE_HEAD = this.user.roles.filter(role => role.name === 'REPAIRING_MAINTENANCE_HEAD');
      if (isREPAIRING_MAINTENANCE_HEAD.length) {
        return true;
      }
      return false;
    }
  },
  computed: {
    ...mapState('contactUs', ['loading', 'baseUrl', 'pagination', 'tickets', 'report']),
    ...mapState('auth', ['user'])
  },
  watch: {
    report(newValue) {
      if (newValue.length > 0) {
        let csv;
        csv = ',,,Ticket Report\n\n';
        csv +=
          'No,Mobile,Email,Severity,Issue,Details,Store ID,Complain Number,Attachment,Department,SubmittedBy,Created At,Resolved Status,Tentative Date,Aging,Cancel Reason (if any)\n';
        newValue.forEach(row => {
          csv += `"${row.rowNum}","${row.mobile}","${row.email}","${row.issuePriority}","${row.issue}","${row.details}","${row.storeid}","${row.complainNumber}","${row.imageUrl}","${row.department}","${row.submittedByName}","${row.createdAt}","${row.currentStatus}","${row.tentativeDate}","${row.aging}","${row.cancelReason}"\n`;
        });
        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = 'Ticket_Report.csv';
        anchor.click();
      }
    }
  }
};
</script>

<style></style>
